"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Aeropay = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
class Aeropay {
}
tslib_1.__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    tslib_1.__metadata("design:type", String)
], Aeropay.prototype, "merchantId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    tslib_1.__metadata("design:type", String)
], Aeropay.prototype, "location", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    tslib_1.__metadata("design:type", String)
], Aeropay.prototype, "merchantLocationId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    tslib_1.__metadata("design:type", String)
], Aeropay.prototype, "merchantLocationUUID", void 0);
exports.Aeropay = Aeropay;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYWVyb3BheS5qcyIsInNvdXJjZVJvb3QiOiIuL3NyYy8iLCJzb3VyY2VzIjpbInBhY2thZ2VzL21vZGVscy9zcmMvYWVyb3BheS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7O0FBQUEscUNBQWlDO0FBRWpDLE1BQWEsT0FBTztDQVNuQjtBQVJHO0lBQUMsSUFBQSxnQkFBTSxFQUFDLEVBQUUsUUFBUSxFQUFFLElBQUksRUFBRSxDQUFDOzsyQ0FDUDtBQUNwQjtJQUFDLElBQUEsZ0JBQU0sRUFBQyxFQUFFLFFBQVEsRUFBRSxJQUFJLEVBQUUsQ0FBQzs7eUNBQ1Q7QUFDbEI7SUFBQyxJQUFBLGdCQUFNLEVBQUMsRUFBRSxRQUFRLEVBQUUsSUFBSSxFQUFFLENBQUM7O21EQUNDO0FBQzVCO0lBQUMsSUFBQSxnQkFBTSxFQUFDLEVBQUUsUUFBUSxFQUFFLElBQUksRUFBRSxDQUFDOztxREFDRztBQVJsQywwQkFTQyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IENvbHVtbiB9IGZyb20gXCJ0eXBlb3JtXCI7XG5cbmV4cG9ydCBjbGFzcyBBZXJvcGF5IHtcbiAgICBAQ29sdW1uKHsgbnVsbGFibGU6IHRydWUgfSlcbiAgICBtZXJjaGFudElkPzogc3RyaW5nO1xuICAgIEBDb2x1bW4oeyBudWxsYWJsZTogdHJ1ZSB9KVxuICAgIGxvY2F0aW9uPzogc3RyaW5nO1xuICAgIEBDb2x1bW4oeyBudWxsYWJsZTogdHJ1ZSB9KVxuICAgIG1lcmNoYW50TG9jYXRpb25JZD86IHN0cmluZztcbiAgICBAQ29sdW1uKHsgbnVsbGFibGU6IHRydWUgfSlcbiAgICBtZXJjaGFudExvY2F0aW9uVVVJRD86IHN0cmluZztcbn0iXX0=